import { Injectable, signal } from '@angular/core';

import { AddEvaluationDropdownStep } from '@recruitee/evaluations-types';

@Injectable()
export class AddEvaluationDropdownStepService {
  private readonly currentStep = signal<AddEvaluationDropdownStep>(
    AddEvaluationDropdownStep.Selection,
  );

  public readonly step = this.currentStep.asReadonly();

  public setStep(step: AddEvaluationDropdownStep): void {
    this.currentStep.set(step);
  }

  public reset(): void {
    this.currentStep.set(AddEvaluationDropdownStep.Selection);
  }
}
